import React, { useEffect } from 'react';
import SupportPage from './support/SupportPage';
import './users/users.css';
import './users/brand.css';
import './support/support.css';

// Admin panel "Destek": the app's feedback as conversations, answered here.
// The answer reaches the user by push (and e-mail when the account has a
// real address). Backend: Backend/app/api/admin_support.py.
export default function SupportInbox() {
  useEffect(() => {
    document.body.classList.add('users-brand');
    return () => document.body.classList.remove('users-brand');
  }, []);
  return <SupportPage />;
}
